module.exports = __webpack_public_path__ + "static/img/icon4.f9c88234.png";